<template>
  <div>

    <v-layout justify-end>
      <v-btn 
      icon
      @click="expand = !expand">
        <v-icon color="green">
          mdi-file-compare
        </v-icon>
      </v-btn>
    </v-layout>

    <v-expand-transition v-if="false">
      <div v-show="expand">
        <v-sheet class="pa-2 ma-2">

          <v-layout justify-end>
            <v-checkbox v-model="settings.showTypes" label="Show types" class="shrink" color="color1"></v-checkbox>
          </v-layout>

          <v-layout>
            <json-viewer :item="item"></json-viewer>
          </v-layout>
          <!-- MAIN -->

        </v-sheet>
      </div>
    </v-expand-transition>

    <v-bottom-sheet v-if="viewMode === 0" v-model="expand">
      <v-card class="c-flex-c1 background" style="max-height: 90vh;overflow: hidden;">

        <v-layout justify-end class="c-flex-00a">
          <v-btn @click="viewMode = 1" icon>
            <v-icon>mdi-page-layout-sidebar-left</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="expand = !expand"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-layout>

        <div class="background" style="overflow: auto;">
          <div>

            <v-layout justify-end>
              <v-checkbox v-model="settings.showTypes" label="Show types" class="shrink" color="color1"></v-checkbox>
            </v-layout>

            <v-layout>
              <json-viewer :item="item"></json-viewer>
            </v-layout>
            <!-- MAIN -->

          </div>
        </div>
      </v-card>
    </v-bottom-sheet>

    <v-navigation-drawer
      v-if="viewMode === 1"
      v-model="expand"
      fixed
      width="500px"
      class="background"
      temporary
    >

      <img src="@/assets/img/icons/pvlogo.png" alt="cardboard box" width="42px">

      <v-btn @click="viewMode = 0" icon>
        <v-icon>mdi-page-layout-footer</v-icon>
      </v-btn>

      <v-divider></v-divider>

      <v-sheet class="pa-2 ma-2">

        <v-layout justify-end>
          <v-checkbox v-model="settings.showTypes" label="Show types" class="shrink" color="color1"></v-checkbox>
        </v-layout>

        <v-layout>
          <json-viewer :item="item"></json-viewer>
        </v-layout>
        <!-- MAIN -->

      </v-sheet>
    </v-navigation-drawer>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['item'],
  data () {
    return {
      viewMode: 1, // 0 = bottom sheet, 1 = nav drawer
      settings: {
        showTypes: false
      },
      expand: false
    }
  },
  components: {
  },
  computed: {
  },
  created () {
    console.warn('t-item-diff can slow down large data sets considerably!')
  }
}
</script>

<style scoped lang="scss">
.panel {
  word-wrap: break-word;
  padding: 6px;
}
/* use a background because sometimes the diff will be whitespace */
::v-deep .highlight-diff {
  background: rgba(2, 0, 250, 0.1);
  font-weight: bold;
  font-size: 14px;
  line-height: 3rem;
}
</style>

